import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";

import {
  Badge,
  Link,
  Modal,
  ModalBody,
  ModalHeader,
  OverflowText,
} from "@transfr-inc/dashboard-components";
import { SearchBox } from "@transfr-inc/dashboard-components/forms";

import { createOrganizationLink } from "@utils/navigation";

import "./orgs.modal.scss";

export function OrgsModal({
  open,
  entity,
  nameProperty = "name",
  onClose,
  breadcrumbLabel,
}) {
  const renderOrgOptionLabel = (org) => {
    const link = createOrganizationLink({
      code: org.code,
      search: { from: breadcrumbLabel },
    });
    return (
      <Link
        routerComponent={NavLink}
        className="org-option-link"
        to={link}
        underline={false}
      >
        <OverflowText text={org.name}>{`${org.name}`}</OverflowText>
        <FontAwesomeIcon icon="fa-regular fa-chevron-right" />
      </Link>
    );
  };

  return (
    <Modal modalClassName={"orgs-modal"} open={open} onClose={onClose}>
      <ModalHeader label="Organizations">
        <div className="modal-title">
          <h2>{entity[nameProperty]}</h2>
          <Badge value={entity.organizations.length} />
        </div>
      </ModalHeader>
      <ModalBody>
        <SearchBox
          className="orgs-search-box"
          placeholder="Search Organizations..."
          data={entity.organizations}
          searchKey="name"
          customOptionLabel={renderOrgOptionLabel}
          clearInputEnabled={false}
          defaultShowAllData
        ></SearchBox>
      </ModalBody>
    </Modal>
  );
}
